export const getRelativeTime = (timestamp: string): string => {
    const diff = Date.now() - new Date(timestamp).getTime()
    const minutes = Math.floor(diff / 60000)
    const hours = Math.floor(diff / 3600000)
    const days = Math.floor(diff / 86400000)

    if (minutes < 1) return 'just now'
    if (minutes < 60) return `${minutes}m ago`
    if (hours < 24) return `${hours}h ago`
    return `${days}d ago`
}

export const formatActor = (actor: string): { display: string; tooltip: string | null } => {
    if (actor.includes('@')) {
        const display = actor
            .split('@')[0]
            .split('.')
            .map((p) => p.charAt(0).toUpperCase() + p.slice(1))
            .join(' ')
        return { display, tooltip: actor }
    }
    return { display: actor, tooltip: null }
}

export const getTargetUrl = (targetType: 'lot' | 'station' | 'device', targetId: string): string => {
    if (targetType === 'lot') return `/lot?lot=${targetId}`
    if (targetType === 'station') return `/station?stationName=${targetId}`
    return `/device?deviceId=${targetId}`
}

export const humanizeField = (field: string): string => {
    const parts = field.split('.').filter((p) => !/^\d+$/.test(p))
    return [...parts.slice(0, 1), ...parts.slice(1).slice(-2)].join(' ').replace(/_/g, ' ')
}
